var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: _vm.pram.id ? "编辑问题" : "新增问题",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "100px", model: _vm.pram } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "问题分类：",
                    prop: "cateName",
                    rules: [
                      {
                        required: true,
                        message: "请填写问题分类",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "请填写问题分类" },
                    model: {
                      value: _vm.pram.cateName,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "cateName", $$v)
                      },
                      expression: "pram.cateName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "问题：",
                    prop: "question",
                    rules: [
                      {
                        required: true,
                        message: "请填写问题",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请填写问题",
                    },
                    model: {
                      value: _vm.pram.question,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "question", $$v)
                      },
                      expression: "pram.question",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "回答：",
                    prop: "answer",
                    rules: [
                      {
                        required: true,
                        message: "请填写回答",
                        trigger: ["blur", "change"],
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      clearable: "",
                      type: "textarea",
                      rows: 4,
                      resize: "none",
                      placeholder: "请填写回答",
                    },
                    model: {
                      value: _vm.pram.answer,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "answer", $$v)
                      },
                      expression: "pram.answer",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }